<template>
  <q-page>
    <div class="justify-center row">

      <div v-if="!$apollo.loading" class="col-10 q-pa-md">
        <div class="col-12 q-gutter-md text-center">
          <h3>Edit Product</h3>
        </div>
        <div class="col q-gutter-md">
          <m-edit-item field="name" type="input" graphqlType="Product" :id="id" />
          <m-edit-item field="description" type="input" input-type="textarea" graphqlType="Product" :id="id" />
          <m-edit-item field="reference" type="input" input-type="input" graphqlType="Product" :id="id" />
<!--          <m-edit-item field="images" type="input" graphqlType="Product" :id="id" />-->
<!--          <m-edit-item field="urlSlug" label="Url Slug" type="input" graphqlType="Product" :id="id" />-->
          <m-edit-item field="attributes" type="list" graphqlType="Product" :id="id" />

          <div>
            <h4>Images</h4>
            <div class="row q-col-gutter justify-center">
              <q-card v-for="(image, i) in product.images" :key="i" class="col-3 q-ma-lg column">
                <q-img :src="image.url" contain/>
                <q-space/>
                <q-card-section class="col-auto">
                  <q-input debounce="1000" :value="image.url" @input="v => updateImage(image.url, v)"/>
                </q-card-section>
                <q-card-section class="col-auto">
<!--                  <q-btn flat dense icon="visibility" />-->
                  <q-btn flat dense icon="delete" @click="deleteImage(image.url)" />
                </q-card-section>
              </q-card>
              <q-card class="col-auto q-ma-lg row justify-center vertical-middle col-3">
                <q-btn flat class="col q-px-xl" icon="add" @click="newImageDialogShowing=true">Add New Image</q-btn>
              </q-card>
            </div>
          </div>

          <div class="row">
            <h4>{{product.skus.length}} Skus</h4>
            <q-space/>
            <q-input dense debounce="300" color="primary" v-model="skuFilter">
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>

          <div class="row">
           <div v-if="product.skus.length > 0" class="col-3">
             <q-btn>Set stock price for all SKUs</q-btn>
             <m-popup-edit v-model="product.skus[0].price" select-on-focus
                           @save="v => editAllSkus({price: Number(v)})" :buttons="true"/>
           </div>
            <div v-if="product.skus.length > 0" class="col-3">
              <q-btn>Set container price for all SKUs</q-btn>
              <m-popup-edit v-model="product.skus[0].containerPrice" select-on-focus
                            @save="v => editAllSkus({containerPrice: Number(v)})" :buttons="true"/>
            </div>
            <div v-if="product.skus.length > 0" class="col-3">
              <q-btn>Set retail price for all SKUs</q-btn>
              <m-popup-edit v-model="product.skus[0].retailPrice" select-on-focus
                            @save="v => editAllSkus({retailPrice: Number(v)})" :buttons="true"/>
            </div>
          </div>

          <div class="row">
          </div>

          <q-table
            class="q-mt-none"
            :data="filteredSkus"
            :columns="skuColumns"
            dense
            hide-bottom
            :pagination.sync="skuTablePagination"
            row-key="colour">

            <template v-slot:body-cell-colour="props">
              <q-td :props="props">
                <span @click="editSkuColour(props.row)">
                  <div :style="{border: '1px silver solid', backgroundColor: props.value.hex, width: '10px',height: '10px'}" class="inline-block"></div>
                  {{props.value.group}} - {{props.value.name}}
                </span>
                <q-btn flat dense icon="gesture" size="xs" @click="createNewSkuColour(props.row)"/>
              </q-td>
            </template>

            <template v-slot:body-cell-price="props">
              <q-td :props="props">
                {{props.value}}
                <m-popup-edit v-model="props.row.price" select-on-focus
                              @save="v => editSku(props.row.id, {price: Number(v)})" :buttons="false"/>
              </q-td>
            </template>

            <template v-slot:body-cell-containerPrice="props">
              <q-td :props="props">
                {{props.value}}
                <m-popup-edit v-model="props.row.containerPrice" select-on-focus
                              @save="v => editSku(props.row.id, {containerPrice: Number(v)})" :buttons="false"/>
              </q-td>
            </template>

            <template v-slot:body-cell-retailPrice="props">
              <q-td :props="props">
                {{props.value}}
                <m-popup-edit v-model="props.row.retailPrice" select-on-focus
                              @save="v => editSku(props.row.id, {retailPrice: Number(v)})" :buttons="false"/>
              </q-td>
            </template>

            <template v-slot:body-cell-stock="props">
              <q-td :props="props">
                {{props.value}}
                <m-popup-edit v-model="props.row.stock" select-on-focus
                              @save="v => editSku(props.row.id, {stock: Number(v)})" :buttons="false"/>
              </q-td>
            </template>

            <template v-slot:body-cell-showInContainer="props">
              <q-td :props="props">
                <q-checkbox dense :value="props.value" @input="v => editSku(props.row.id, {showInContainer: v})"></q-checkbox>
              </q-td>
            </template>

            <template v-slot:body-cell-showInRetail="props">
              <q-td :props="props">
                <q-checkbox dense :value="props.value" @input="v => editSku(props.row.id, {showInRetail: v})"></q-checkbox>
              </q-td>
            </template>

            <template v-slot:body-cell-hideInStock="props">
              <q-td :props="props">
                <q-checkbox dense :value="props.value" @input="v => editSku(props.row.id, {hideInStock: v})"></q-checkbox>
              </q-td>
            </template>

            <template v-slot:body-cell-deleted="props">
              <q-td :props="props">
                <div v-if="props.value" style="width: 60px; border: 1px solid #C5161C;color:#C5161C;border-radius:3px">Deleted</div>
                <!-- <div v-if="props.value" style="width: 60px; background-color:silver;color:white;border-radius:3px">Active</div> -->
                <div v-else style="width: 60px; border: 1px solid green;color:green;border-radius:3px">In Use</div>
                <!-- <q-icon color="red" size="sm" name="auto_delete" v-if="props.value"/> -->
              </q-td>
            </template>            

            <template v-slot:body-cell-actions="props">
              <q-td :props="props">
                <q-btn flat dense icon="delete" @click="deleteSku(props.row)"/>
              </q-td>
            </template>

            <template v-slot:bottom-row>
              <q-tr>
                <q-td colspan="100%">
                  <q-btn dense flat icon="add" class="full-width" @click="addSku">Add New Sku</q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      <div>
    <div>
        <q-card style="margin-top:20px">
        <!-- <q-card style="width:600px; margin-top:20px"> -->
            <q-card-section>
                <div style="font-size:22px;">Product Details Page</div>
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div id="input_set_component">
                    <div style="margin-top:20px">
                        <div style="display:inline; font-size:16px; ">Subtitle (Short Description)</div>
                        <div style="display:inline; float:right">
                            <q-checkbox dense left-label v-model="show_subtitle" label="Hide" checked-icon="task_alt" unchecked-icon="highlight_off" />
                        </div>
                    </div>
                    <div>
                        <q-input bg-color="grey-2" outlined dense v-model="subtitle" type="text" />
                    </div>
                </div>     
                <div id="input_set_component">
                    <div style="margin-top:20px">
                        <div style="font-size:16px;">Options</div>
                        <div style="margin: 10px" >
                            <div style="display:block"><q-checkbox dense v-model="opt_show_tag" label="Show 'New' Tag" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                            <div style="display:block"><q-checkbox dense v-model="opt_show_rating" label="Show ranking (Stars)" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                            <div style="display:block"><q-checkbox dense v-model="opt_show_whishing_btn" label="Show 'Add to Whishing List' button" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                            <div style="display:block"><q-checkbox dense v-model="opt_show_fullscreen" label="Show 'Fullscreen' button on images" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                            <div style="display:block"><q-checkbox dense v-model="opt_autoplay_images" label="Autoplay images" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                            <div style="display:block"><q-checkbox dense v-model="opt_show_qty_colour" label="Show quantities inside colour selector" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>                </div>
                    </div>
                </div>                 
            </q-card-section>
        </q-card>
<q-card style="margin-top:20px">
        <q-card-section>
            <div style="font-size:22px; display:inline">Features Panel</div>
            <div style="display:inline; float:right">
                <q-checkbox dense left-label v-model="show_features" label="Show Panel" checked-icon="task_alt" unchecked-icon="highlight_off" />
            </div>                
        </q-card-section>
        <q-separator />
        <q-card-section>
            <div id="panel_standard">  
                <div class="text-right">      
                    <q-toggle v-model="show_editor" color="primary" label="Show Editor" left-label />
                </div>                                     
                <div>
                    <!-- XXXX -->
                    <div v-if="show_editor" class="q-pa-md q-gutter-sm">
                        <q-editor
                        v-model="features_content"
                        :dense="$q.screen.lt.md"
                        :toolbar="[
                            [
                            {
                                label: $q.lang.editor.align,
                                icon: $q.iconSet.editor.align,
                                fixedLabel: true,
                                list: 'only-icons',
                                options: ['left', 'center', 'right', 'justify']
                            },
                            {
                                label: $q.lang.editor.align,
                                icon: $q.iconSet.editor.align,
                                fixedLabel: true,
                                options: ['left', 'center', 'right', 'justify']
                            }
                            ],
                            ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                            ['token', 'hr', 'link', 'custom_btn'],
                            ['print', 'fullscreen'],
                            [
                            {
                                label: $q.lang.editor.formatting,
                                icon: $q.iconSet.editor.formatting,
                                list: 'no-icons',
                                options: [
                                'p',
                                'h1',
                                'h2',
                                'h3',
                                'h4',
                                'h5',
                                'h6',
                                'code'
                                ]
                            },
                            {
                                label: $q.lang.editor.fontSize,
                                icon: $q.iconSet.editor.fontSize,
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: [
                                'size-1',
                                'size-2',
                                'size-3',
                                'size-4',
                                'size-5',
                                'size-6',
                                'size-7'
                                ]
                            },
                            {
                                label: $q.lang.editor.defaultFont,
                                icon: $q.iconSet.editor.font,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: [
                                'default_font',
                                'arial',
                                'arial_black',
                                'comic_sans',
                                'courier_new',
                                'impact',
                                'lucida_grande',
                                'times_new_roman',
                                'verdana'
                                ]
                            },
                            'removeFormat'
                            ],
                            ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                            ['undo', 'redo'],
                            ['viewsource']
                        ]"
                        :fonts="{
                            arial: 'Arial',
                            arial_black: 'Arial Black',
                            comic_sans: 'Comic Sans MS',
                            courier_new: 'Courier New',
                            impact: 'Impact',
                            lucida_grande: 'Lucida Grande',
                            times_new_roman: 'Times New Roman',
                            verdana: 'Verdana'
                        }"
                        />
                    </div>
                    <!-- END XXXX -->

                    <!-- PREVIEW -->
                    <div style="font-size:16px; ">Preview</div>
                    <div style="margin: 15px; border: 1px solid grey; min-height:100px">
                        <div v-html="features_content"></div>
                    </div>
                    <!-- END PREV -->
                </div>
            </div>                                                                
        </q-card-section>        
    </q-card>

    <q-card style="margin-top:20px">
        <q-card-section>
            <div style="font-size:22px; display:inline">Technical Details Panel</div>
            <div style="display:inline; float:right">
                <q-checkbox dense left-label v-model="show_td" label="Show Panel" checked-icon="task_alt" unchecked-icon="highlight_off" />
            </div>                
        </q-card-section>
        <q-separator />
        <q-card-section>
            <div id="panel_standard">  
                <div class="text-right">      
                    <q-toggle v-model="show_editor2" color="primary" label="Show Editor" left-label />
                </div>                                     
                <div>
                    <!-- XXXX -->
                    <div v-if="show_editor2" class="q-pa-md q-gutter-sm">
                        <q-editor
                        v-model="td_content"
                        :dense="$q.screen.lt.md"
                        :toolbar="[
                            [
                            {
                                label: $q.lang.editor.align,
                                icon: $q.iconSet.editor.align,
                                fixedLabel: true,
                                list: 'only-icons',
                                options: ['left', 'center', 'right', 'justify']
                            },
                            {
                                label: $q.lang.editor.align,
                                icon: $q.iconSet.editor.align,
                                fixedLabel: true,
                                options: ['left', 'center', 'right', 'justify']
                            }
                            ],
                            ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                            ['token', 'hr', 'link', 'custom_btn'],
                            ['print', 'fullscreen'],
                            [
                            {
                                label: $q.lang.editor.formatting,
                                icon: $q.iconSet.editor.formatting,
                                list: 'no-icons',
                                options: [
                                'p',
                                'h1',
                                'h2',
                                'h3',
                                'h4',
                                'h5',
                                'h6',
                                'code'
                                ]
                            },
                            {
                                label: $q.lang.editor.fontSize,
                                icon: $q.iconSet.editor.fontSize,
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: [
                                'size-1',
                                'size-2',
                                'size-3',
                                'size-4',
                                'size-5',
                                'size-6',
                                'size-7'
                                ]
                            },
                            {
                                label: $q.lang.editor.defaultFont,
                                icon: $q.iconSet.editor.font,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: [
                                'default_font',
                                'arial',
                                'arial_black',
                                'comic_sans',
                                'courier_new',
                                'impact',
                                'lucida_grande',
                                'times_new_roman',
                                'verdana'
                                ]
                            },
                            'removeFormat'
                            ],
                            ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                            ['undo', 'redo'],
                            ['viewsource']
                        ]"
                        :fonts="{
                            arial: 'Arial',
                            arial_black: 'Arial Black',
                            comic_sans: 'Comic Sans MS',
                            courier_new: 'Courier New',
                            impact: 'Impact',
                            lucida_grande: 'Lucida Grande',
                            times_new_roman: 'Times New Roman',
                            verdana: 'Verdana'
                        }"
                        />
                    </div>
                    <!-- END XXXX -->

                    <!-- PREVIEW -->
                    <div style="font-size:16px; ">Preview</div>
                    <div style="margin: 15px; border: 1px solid grey; min-height:100px">
                        <div v-html="td_content"></div>
                    </div>
                    <!-- END PREV -->
                </div>
            </div>                                                                
        </q-card-section>        
    </q-card>


    <q-card style="margin-top:20px">
        <q-card-section>
            <div style="font-size:22px; display:inline">Rating and Review Panel</div>
            <div style="display:inline; float:right">
                <q-checkbox dense left-label v-model="show_reviews" label="Show Panel" checked-icon="task_alt" unchecked-icon="highlight_off" />
            </div>                            
        </q-card-section>
        <q-separator />
        <q-card-section>
            <div id="input_set_component">
                <div style="margin-top:20px">
                    <div style="margin: 10px" >
                        <div style="display:block"><q-checkbox dense v-model="rev_show_rating_breakdown" label="Show 'Rating Breakdown' subpanel" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                        <div style="display:block"><q-checkbox dense v-model="rev_show_product_recomendation_subpanel" label="Show 'Product Recomendation' subpanel " checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                        <div style="display:block"><q-checkbox dense v-model="rev_show_write_btn" label="Show 'Write a Review' button" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>
                        <div style="display:block"><q-checkbox dense v-model="rev_show_helpful_line" label="Show 'Helpful' line on individual reviews" checked-icon="task_alt" unchecked-icon="highlight_off" /></div>                    
                    </div>
                </div>
            </div>                                                                  
        </q-card-section>        
    </q-card>
    <div style="margin-top:20px">
      <q-btn color="primary" icon="check" label="Update" @click="updatePD" v-if="pdLoaded"/>
      <q-btn color="primary" icon="check" label="Save" @click="addPD" v-else/>
    </div>




    </div>











        
        
        
        </div>
      </div>
    </div>
    <q-dialog v-model="newImageDialogShowing">
      <q-card class="column">
        <q-uploader
          :factory="uploaderFactory"
          label="Upload Nes Image"
          :max-file-size="20000000"
          accept=".jpg,.jpeg,.png,.gif"
          auto-upload
          hide-upload-btn
          style="max-width: 300px"
        />
        <q-btn @click="addNewImage('')" flat class="justify-center">Don't Upload An Image</q-btn>
      </q-card>
    </q-dialog>

<!--    <q-card v-for="sku in filteredSkus" v-bind:key="sku.id" class="q-pa-md">-->
<!--      <m-edit-item field="options" type="list" graphqlType="Sku" :id="sku.id" />-->
<!--      <m-edit-item field="price" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="stock" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="containerPrice" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="showInContainer" type="checkbox" graphqlType="Sku" :id="sku.id" />-->
<!--      <q-btn icon="delete" class="q-mt-md" @click="deleteSku(sku)">Delete Sku</q-btn>-->
<!--    </q-card>-->

<!--    <colour-select-dialog :value="colourSelectDialogShowing"></colour-select-dialog>-->



  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import MEditItem from '../../components/ui/admin/MEditItem'
import adminNotifyError from '../../util/adminNotifyError'
import { formatCurrency } from '../../util/string'
import MPopupEdit from '../../components/ui/MPopupEdit'
import ColourSelectDialog from '../../components/ColourSelectDialog'

export default {
  name: 'Product',
  components: { MPopupEdit, MEditItem },
  apollo: {
    product () {
      return {
        query: gql`query product ($id: ID!) {
          product (id: $id) {
            id
            name
            description
            reference
            images {
              url
              name
            }
            attributes
            urlSlug
            skus {
              id
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showInRetail
              hideInStock
              stock
              colour
              deleted
            }
          }
        }
        `,
        variables: {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {


      checkbox: true,
      checkbox_false: false,
      qeditor:"Hello",
      show_editor:false,
      show_editor2:false,
      show_editor3:false,

      productName:"",
      subtitle:"",
      show_subtitle:true,
      show_description:true,
      description:"",
      opt_show_tag:true,
      opt_show_rating:true,
      opt_show_whishing_btn:true,
      opt_show_fullscreen:true,
      opt_autoplay_images:true,
      opt_show_qty_colour:true,

      show_features:true,
      features_content:"",
      show_td:true,
      td_content:"",
      show_reviews:true,
      rev_show_rating_breakdown:true,
      rev_show_product_recomendation_subpanel:true,
      rev_show_write_btn:true,
      rev_show_helpful_line:true,

      reference:"",
      barcode:"",
      type:"",
      brand:"",
      pdLoaded: false,




      colourSelectDialogShowing: true,
      newImageDialogShowing: false,
      skuTablePagination: { rowsPerPage: 0 },
      skuFilter: '',
      skuColumns: [
        { name: 'colour', label: 'Colour', align: 'left', field: row => row.options?.colour, sortable: true },
        { name: 'price', label: 'Stock Price', align: 'right', field: 'price', sortable: true, format: formatCurrency },
        { name: 'containerPrice', label: 'Container Price', align: 'right', field: 'containerPrice', sortable: true, format: formatCurrency },
        { name: 'retailPrice', label: 'Retail Price', align: 'right', field: 'retailPrice', sortable: true, format: formatCurrency },
        { name: 'stock', label: 'Stock', align: 'right', field: 'stock', sortable: true },
        { name: 'showInContainer', label: 'Show In Container', align: 'center', field: 'showInContainer', sortable: true },
        { name: 'showInRetail', label: 'Show In Retail', align: 'center', field: row => row.showInRetail || false, sortable: true },
        { name: 'hideInStock', label: 'Hide In Stock', align: 'center', field: row => row.hideInStock || false, sortable: true },
        { name: 'deleted', label: 'Status', align: 'center', field: row => row.deleted || false, sortable: true },        
        { name: 'actions', label: '', align: 'center', sortable: false }
        // { name: 'Cost Per Hold', label: 'Cost Per Hold', align: 'right', field: row => row.costPerHold, sortable: false, format: formatCurrency }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    filteredSkus () {
      return this.product?.skus?.filter?.(sku => JSON.stringify(sku?.options?.colour)?.toLowerCase()?.includes?.(this.skuFilter.toLowerCase()))
    }
  },
  methods: {
    async uploaderFactory (files) {
      if (!files || !files.length) return
      try {
        let result = await this.$apollo.mutate({
          mutation: gql`mutation uploadProductImage ($image: Upload!, $path: String) {
            uploadProductImage(image: $image, path: $path)
          }
        `,
          variables: {
            image: files[0],
            path: this.product?.attributes?.brand
          },
          update: (store, response) => {
            this.newImageDialogShowing = false
            return response
          }
        })
        await this.addNewImage(result.data.uploadProductImage)
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async addNewImage (imagePath) {
      try {
        let newImages = this.product.images.slice(0).map(img => {
          delete img['__typename']
          return img
        })
        newImages.push({
          name: null,
          url: imagePath
        })
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
        this.newImageDialogShowing = false
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    editSkuColour (sku) {
      this.$q.dialog({
        component: ColourSelectDialog
      }).onOk((value) => {
        this.editSku(sku.id, { options: { colour: JSON.stringify(value) } })
      })
    },
    createNewSkuColour (sku) {
      this.$q.dialog({
        title: 'Enter a JSON object to be a new colour',
        cancel: true,
        prompt: {
          model: JSON.stringify(sku.options.colour),
          type: 'text'
        }
      }).onOk((value) => {
        this.editSku(sku.id, { options: { colour: value } })
      })
    },
    async editAllSkus (changes) {
      if (this.skuFilter) {
        this.$q.dialog({
          title: 'Could not write.',
          description: 'You must first clear the sku filter here in the sku section.',
          cancel: true
        })
        return
      }
      const promises = []
      this.product.skus.forEach((sku) => {
        promises.push(this.editSku(sku.id, changes))
      })
      await Promise.all(promises)
    },
    async editSku (skuId, changes) {
      // {"operationName":"editSku","variables":{"id":"5de9a8e5017f7816e4052045","input":{"stock":1}},"query":"mutation editSku($id: ID!, $input: SkuInput!) {\n  editSku(id: $id, input: $input) {\n    id\n    stock\n    __typename\n  }\n}\n"}
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation editSku ($id: ID!, $input: SkuInput!) {
            editSku(id: $id, input: $input) {
              id
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showInRetail
              hideInStock
              stock
            }
          }
        `,
          variables: {
            id: skuId,
            input: changes
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to edit sku.', error)
      }
    },
    async deleteImage (imageUrl) {
      this.$q.dialog({
        title: 'Delete Order',
        message: `Are you sure you want to delete this image?`,
        cancel: true
      }).onOk(() => {
        this.deleteImageWithoutAsking(imageUrl)
      })
    },
    async deleteImageWithoutAsking (imageUrl) {
      try {
        let newImages = this.product.images.slice(0)
          .filter(img => img.url !== imageUrl)
          .map(img => {
            delete img['__typename']
            return img
          })
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async updateImage (imageUrl, newUrl) {
      try {
        let newImages = this.product.images.slice(0)
          .map(img => {
            delete img['__typename']
            return img
          })
        let imageToEdit = newImages.find(img => img.url === imageUrl)
        if (!imageToEdit) throw new Error(`Could Not Find Image to edit with url ${imageUrl}.`)
        imageToEdit.url = newUrl
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async deleteSku (sku) {
      this.$q.dialog({
        title: 'Delete Sku',
        message: `Are you sure you want to delete this sku?  You should only delete skus if you JUST created it accidentally.  Otherwise you can corrupt orders that contain this sku.`,
        cancel: true
      }).onOk(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteSku($id: ID!) {
                  deleteSku (id: $id)
              }
            `,
            variables: {
              id: sku.id
            }
          })
          await this.$apollo.queries.product.refetch()
        } catch (error) {

          this.$q.notify({
            message: `Error deleting Sku! ${error.message}`,
            color: 'negative',
            icon: 'report_problem'
          })
        }
      })
    },
    async addSku (row) {
      try {
        const input = {
          productId: this.id,
          price: 0,
          stock: 0,
          barcode: '',
          attributes: [],
          options: {
            colour: JSON.stringify({ 'name': '07-13', 'superGroup': 'Purple', 'group': 'Purple', 'hex': '#800f7f' })
          }
        }
        await this.$apollo.mutate({
          mutation: gql`
            mutation addSku($input: SkuInput!) {
                addSku (input: $input) { id }
            }
          `,
          variables: {
            input
          }
        })
        await this.$apollo.queries.product.refetch()
      } catch (error) {
        console.log(error)
        this.$q.notify({
          message: `Error adding Sku! ${error.message}`,
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.validateRow(row)
    },
    async addPD(){
        let input = {
            productId: this.id,
            basic_details:{
                subtitle: this.subtitle,
                show_subtitle: this.show_subtitle,
                options: {
                    show_status_tag: this.opt_show_tag,
                    show_rating_stars: this.opt_show_rating,
                    show_whishing_btn: this.opt_show_whishing_btn,
                    show_fullscreen_btn: this.opt_show_fullscreen,
                    autoplay_gallery: this.opt_show_fullscreen,
                    show_qty_colour: this.opt_show_qty_colour
                }
            },
            feature_panel:{
                show: this.show_features,
                content:this.features_content
            },
            technical_details_panel:{
                show: this.show_td,
                content:this.td_content
            },
            review_panel:{
                show: this.show_reviews,
                show_rating_breakdown: this.rev_show_rating_breakdown,
                show_product_recomendation_subpanel: this.rev_show_product_recomendation_subpanel,
                show_write_btn: this.rev_show_write_btn,
                show_helpful_line: this.rev_show_helpful_line
            }                        
        }
        let result = await this.addProductDetails_mutation(input)
        console.log('RES',result); 
    },    
    async addProductDetails_mutation(input){      
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation addProductDetails ($input: ProductDetailsInput!) {
            addProductDetails(input: $input) {
                id
                productId
                basic_details {
                    subtitle
                    show_subtitle
                    options
                }
                feature_panel {
                    show
                    content
                }
                technical_details_panel{
                    show
                    content
                }
                review_panel{
                    show
                    show_rating_breakdown
                    show_product_recomendation_subpanel
                    show_write_btn
                    show_helpful_line
                }
            }
          }
        `,
          variables: {
            input: input
          }
        })
        return result.data.addProductDetails;
      } catch (error) {
        console.log("addProductDetails_query Error:", error)
        throw new Error(error);      
      }
    },
    async getPD(){
        let id = this.id
        let result = await this.getProductDetails_query(id)

        console.log('result',result);
        
        if(result.id){
          let basic_details = result.basic_details;
          let feature_panel = result.feature_panel
          let technical_details_panel = result.technical_details_panel
          let review_panel =  result.review_panel

          this.subtitle = basic_details.subtitle      
          this.show_subtitle = basic_details.show_subtitle
          this.opt_show_tag = basic_details.options.show_status_tag
          this.opt_show_rating = basic_details.options.show_rating_stars
          this.opt_show_whishing_btn = basic_details.options.show_whishing_btn
          this.opt_show_fullscreen = basic_details.options.show_fullscreen_btn
          this.opt_show_fullscreen = basic_details.options.autoplay_gallery
          this.opt_show_qty_colour = basic_details.options.show_qty_colour

          this.show_features = feature_panel.show
          this.features_content =  feature_panel.content

          this.show_td = technical_details_panel.show
          this.td_content =  technical_details_panel.content



          this.show_reviews = review_panel.show
          this.rev_show_rating_breakdown = review_panel.show_rating_breakdown
          this.rev_show_product_recomendation_subpanel = review_panel.show_product_recomendation_subpanel
          this.rev_show_write_btn = review_panel.show_write_btn
          this.rev_show_helpful_line = review_panel.show_helpful_line
          this.pdLoaded = true                  
        }               
    },
    async getProductDetails_query(id){
      try {
        const result = await this.$apollo.query({
          query: gql`query productDetails ($id: ID!) {
            productDetails (id: $id) {
                id
                productId
                basic_details {
                    subtitle
                    show_subtitle
                    options
                }
                feature_panel {
                    show
                    content
                }
                technical_details_panel{
                    show
                    content
                }
                review_panel{
                    show
                    show_rating_breakdown
                    show_product_recomendation_subpanel
                    show_write_btn
                    show_helpful_line
                }
            }
          }
        `,
        variables: {
          id: id
        },         
        fetchPolicy: 'network-only'
        })
        return result.data.productDetails;
      } catch (error) {
        console.log("getProductDetails_query Error:", error)
        throw new Error(error);    
      }      
    }                
  },
  async mounted(){
    await this.getPD()
  }
}
</script>

<style scoped>

</style>
